<app-button 
    #backButton 
    [type]="buttonType" 
    [custom]="['dark-button']"
    (event)="back()" 
    [class]="showElement() ? 'md:mr-2' : 'hidden' "
>
    
    <svg ngProjectAs="icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor" class="size-3.5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
    </svg>
    
</app-button>
